import { SalvLabelProps } from '@salvapp/ui-components/build/SalvLabel/SalvLabel.types';
import { SalvLabel, SalvTooltipWrapper } from '@salvapp/ui-components';
import React from 'react';
import { InternalApiEntityGroup } from '../../../api-internal';

interface FullCalculationLabelProps {
  segment: InternalApiEntityGroup;
}
export const FullCalculationLabel = ({ segment }: FullCalculationLabelProps) => {
  const { fullCalculationState } = segment;
  const labelProps: SalvLabelProps | undefined =
    fullCalculationState === 'STARTED'
      ? {
          variant: 'warning',
          children: 'Full Calculation Started',
        }
      : fullCalculationState === 'FAILED'
        ? {
            variant: 'danger',
            children: 'Full Calculation Failed',
          }
        : undefined;

  return labelProps ? (
    <SalvTooltipWrapper
      tooltip={
        fullCalculationState === 'STARTED'
          ? 'Segments need time to calculate, which may vary based on the amount of Entities. Once Full Calculation is complete the Segment will be ready for use.'
          : fullCalculationState === 'FAILED'
            ? "Full Calculation has failed. You can review the failure in the Segment's Calculation Log"
            : ''
      }
    >
      <SalvLabel variant={labelProps.variant}>{labelProps.children}</SalvLabel>
    </SalvTooltipWrapper>
  ) : undefined;
};
